import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
// import axios from 'axios';
import Select from 'react-select';
import _ from 'lodash';

import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/payrollActions';
import { Actions as ALLOWANCEACTIONS } from '../../store/actions/allowanceActions';
import { Actions as OVERTIMEACTIONS } from '../../store/actions/overtimeActions';
import Tooltip from '@/tooltip';

const TaxRow = ({ tax, currency }) => {

  return (

    <>
      <div style={{ gridColumn: "span 2 / span 6" }}>
        {tax.taxName} {/*(4weeks)*/}
        {/*if SSC need to open weeks popup and weekly salary somewhere*/}
        {/*

          <td>Weekly Salary</td>
          <td>{currency}123</td>
          <span className="mondays hide">
            <label className="css-input css-checkbox css-checkbox-primary remove-margin-t remove-margin-b horiz" data-toggle="tooltip" data-placement="top" title="Monday, 3rd February">
              <input type="checkbox" name="taxable-weeks[1]" value="2020-02-03" checked="checked"/><span style={{marginLeft: 0}}></span>1
            </label>
            <label className="css-input css-checkbox css-checkbox-primary remove-margin-t remove-margin-b horiz" data-toggle="tooltip" data-placement="top" title="Monday, 10th February">
              <input type="checkbox" name="taxable-weeks[2]" value="2020-02-10" checked="checked"/><span style={{marginLeft: 0}}></span>2
            </label>
            <label className="css-input css-checkbox css-checkbox-primary remove-margin-t remove-margin-b horiz" data-toggle="tooltip" data-placement="top" title="Monday, 17th February">
              <input type="checkbox" name="taxable-weeks[3]" value="2020-02-17" checked="checked"/><span style={{marginLeft: 0}}></span>3
            </label>
            <label className="css-input css-checkbox css-checkbox-primary remove-margin-t remove-margin-b horiz" data-toggle="tooltip" data-placement="top" title="Monday, 24th February">
              <input type="checkbox" name="taxable-weeks[4]" value="2020-02-24" checked="checked"/><span style={{marginLeft: 0}}></span>4
            </label>
          </span>
        */}
      </div>
      <div style={{ gridColumn: "span 2 / span 6" }}>
          {tax.employeeContribution || tax.employeeCalculation?.length || tax.employeeBreakdown?.length ?
            <Tooltip
              content={
                <div style={{ whiteSpace: "nowrap" }}>
                  <p style={{ color: 'white', fontWeight: 700 }}>{tax.taxName} {tax.taxCategory} Explained</p>
                  <ul style={{ whiteSpace: "nowrap", textAlign: "left" }}>
                    <>
                      {tax.employeeCalculation ? tax.employeeCalculation.map(t => <li>{t}</li>) : null}
                      {tax.employeeBreakdown ?
                        <>
                          <li>Taxable: {tax.taxable}</li>
                          <li>_________________________</li>
                          {tax.employeeBreakdown
                              ?.filter(item => !!item.amount)
                              ?.map(item => (
                            <>
                              {item.calculation?.map(t => <li>{t}</li>)}
                              Amount: {item.amount}
                              <li>_________________________</li>
                            </>
                          ))}
                          Total: {tax.employeeContribution}
                        </>
                        : null}
                    </>
                  </ul>
                </div>
              }
              tagName="span">
              {tax.employeeContribution ? (parseFloat(tax.employeeContribution).toFixed(2)) : (tax.payer != "Employer" && `${tax.amount ? parseFloat(tax.amount).toFixed(2) : 0}`)}
            </Tooltip>
            : null
          }
      </div>
      <div style={{ gridColumn: "span 2 / span 6" }}>
          {/* only show if there is a value or a calculation */ }
          {
            tax.employerContribution || tax.employerCalculation?.length || tax.employerBreakdown?.length ?
            <Tooltip
              styles={{ minWidth: 500 }}
              content={
                <div style={{ whiteSpace: "nowrap" }}>
                  <p style={{ color: 'white', fontWeight: 700 }}>{tax.taxName} {tax.taxCategory} Explained</p>
                  <ul style={{ whiteSpace: "nowrap", textAlign: "left" }}>
                    <>
                      {tax.employerCalculation ? tax.employerCalculation.map(t => <li>{t}</li>) : null}
                      {tax.employerBreakdown ?
                        <>
                          <li>Taxable: {tax.taxable}</li>
                          {tax.employerBreakdown?.filter(item => !!item.amount)?.map(item => (
                            <>
                              {item.calculation?.map(t => <li>{t}</li>)}
                              Amount: {item.amount}
                              <li>_________________________</li>
                            </>
                          ))}
                          Total: {tax.employerContribution}
                        </>
                        : null}
                    </>
                  </ul>
                </div>
              }
              tagName="span">
              {tax.employerContribution ? (parseFloat(tax.employerContribution).toFixed(2)) : (tax.payer != "Employee" && `${tax.amount ? parseFloat(tax.amount).toFixed(2) : 0}`)}
            </Tooltip>
            : null
          }
      </div>
    </>


  )
}

const mapStateToProps = (state) => {
  console.log('state', state && state.grades)
  return {
    ...state.payroll,
    currency: state.company?.settings?.currency,
    // ...state.employees,
  }
}

const mapDispatchToProps = dispatch => ({
  overtimeGetList: () => dispatch(OVERTIMEACTIONS.overtimeGetList()),
  allowanceGetList: () => dispatch(ALLOWANCEACTIONS.allowanceGetList()),
  payrollGetList: (payrunID) => dispatch(ACTIONS.payrollGetList(payrunID)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaxRow)

